import React, { Component } from "react";
import { Link } from 'react-router-dom'

export default class Questions extends Component {

  constructor(props) {
    super(props);
    this.state = {items: []};


    // Fast redirection?
    if(!this.state.user || this.state.user.role != 'admin')
      window.location.replace('/login');
    // Bindings
    this.onDelete = this.onDelete.bind(this);
  }

  componentDidMount() {
    this.questionList();
  }

  questionList() {
    fetch(process.env.REACT_APP_API_URL + '/questions')
      .then( ( response ) => response.json() )
      .then( ( data ) => {
        this.setState({ items: data })
      });
  }

  onDelete(e) {
    e.preventDefault();
    var qId = e.target.dataset.qid;
    fetch(process.env.REACT_APP_API_URL + '/questions/' + qId + '/delete', {
        method: 'POST'
      })
      .then( ( response ) => response.json() )
      .then( ( data ) => {
        this.questionList();
      });
  }

  render() {
    console.log(this.state.items);
    const items = this.state.items.map((item, i) => (
        <li key={i} className="list-group-item">
          { item.question }<br/>
          <span className="badge badge-primary">{ item.category && item.category.name }</span>
          &nbsp;&nbsp;&nbsp;
          <span className="badge badge-secondary">{ item.category_vs && item.category_vs.name }</span>
          <div className="float-right">
            <Link to={"/questions/" + item._id + "/edit"} className="btn btn-sm btn-primary">Editar</Link>
            <button className="btn btn-sm btn-danger" data-qid={item._id} onClick={ this.onDelete }>Eliminar</button>
          </div>
        </li>
    ));
    return (
      <div id="questions" className="container">
        <ul className="list-group">
          { items }
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/Questions.jsx